export default "__VITE_ASSET__DsbCCUEg__"